const excludedRoutes = [
  "/change-password",
  "/register",
  "/otp",
  "/error-404",
  "/error-403",
  "/error-500",
  "/coming-soon",
  "/under-maintenance",
  "/job-list",
  "/job-view",
  "/forgot-password",
  "/login/token",
  "/lock-screen",
  "/accordion",
  "/alerts",
  "/breadcrumbs",
  "/avatar",
  "/badges",
  "/buttons",
  "/buttongroup",
  "/cards",
  "/dropdowns",
  "/grid",
  "/images",
  "/media",
  "/modal",
  "/offcanvas",
  "/pagination",
  "/popover",
  "/progress",
  "/placeholders",
  "/rangeslider",
  "/spinners",
  "/sweetalert",
  "/nav-tabs",
  "/toastr",
  "/tooltips",
  "/typography",
  "/video",
  "/lightbox",
  "/carousel",
  "/borders",
  "/breadcrumb",
  "/colors",
  "/modals",
  "/spinner",
];

export default excludedRoutes;
